import { gql } from "@apollo/client"

import { useMutation, InjectedOptions } from "@oysterhr/core"

import { CreateDraftGrantInput, CreateDraftGrantPayload } from "@oysterhr/schema"

const CREATE_EQUITY_GRANT_DRAFT = gql`
  mutation createDraftEquityGrant(
    $engagementId: ID!
    $planType: EquityPlanTypeEnum!
    $equityType: EquityTypeEnum!
    $equitySubType: EquitySubTypeEnum
    $grantDate: ISO8601Date!
    $grantAmount: Float
    $grantAmountCurrency: String
    $grantShares: Float
    $vestingCliffMonths: Int
    $vestingCliffShares: Float
    $vestingScheduleMonths: Int
    $vestingStartDate: ISO8601Date!
  ) {
    createDraftEquityGrant(
      input: {
        engagementId: $engagementId
        planType: $planType
        equityType: $equityType
        equitySubType: $equitySubType
        grantDate: $grantDate
        grantAmount: $grantAmount
        grantAmountCurrency: $grantAmountCurrency
        grantShares: $grantShares
        vestingStartDate: $vestingStartDate
        vestingCliffMonths: $vestingCliffMonths
        vestingCliffShares: $vestingCliffShares
        vestingScheduleMonths: $vestingScheduleMonths
      }
    ) {
      equityGrant {
        id
      }
      errors
    }
  }
`
type MutationPayload = { createDraftEquityGrant: CreateDraftGrantPayload; errors: [] }

export const useCreateEquityGrantDraft = (
  options?: InjectedOptions<MutationPayload, CreateDraftGrantInput>,
) => {
  return useMutation(CREATE_EQUITY_GRANT_DRAFT, options)
}
